$(document).ready(function() {
  // Add ARIA attributes to the drawer
  setTimeout(function() {
    $('.drawer-wrapper').attr({
      role: 'dialog',
      'aria-modal': 'true',
      tabindex: '-1',
      title: 'Cart'
    });
  }, 500);

  // When user clicks the Add to Cart triggers
  $(document).on('click', '.ada-cart-fix, #AddToCart', function() {
    setTimeout(function() {
      $('.drawer-wrapper').attr('tabindex', '-1').focus();
    }, 500);
  });
});


$(document).ready(function() {
    $('.search-input-and-close input').attr('aria-label', 'Search for products, brands...');
    $('.splide__arrows .splide__arrow--prev').append('<span class="visually-hidden-js">Previous Slide</span>');
    $('.splide__arrows .splide__arrow--next').append('<span class="visually-hidden-js">Next Slide</span>');
    $('.featured-collection .tabbed-product-list-wrapper').attr('role','tabpanel');
    $('a[href="/pages/accessibility-statement"]').attr('id','accessibility');
    $('.ada-erorr').removeAttr('aria-label');
    $('section.cart-reminder').attr('aria-hidden', 'true');
    $('a[href="https://www.shopify.com/legal/cookies"]').attr('aria-label', 'https://www.shopify.com/legal/cookies , this Link Will open in a new tab.');
    $('a[href="http://www.allaboutdnt.com/"]').attr('aria-label', 'http://www.allaboutdnt.com/ , this Link Will open in a new tab.');
    $('a[href="https://privacy.shopify.com/en"]').attr('aria-label', 'https://privacy.shopify.com/en , this Link Will open in a new tab.');
    $('br').attr('aria-hidden','true');
    $('#ola_orderLookUp_formWrapper h1').each(function() {
        if ($(this).is(':empty')) {
            $(this).remove();
        }
    });
    $('a[href^="mailto:"]').each(function () {
      var email = $(this).attr('href').replace('mailto:', '');
      var ariaLabel = 'Email at: ' + email;
      
      $(this).attr('aria-label', ariaLabel);
  });
    $('#search-input-wrapper .search-input-form input').attr('role','combobox');
    $('#search-input-wrapper .search-results .search-results-inner').attr('role','listbox');
    $('#search-input-wrapper .clear-link').attr('role','button');
    $('#search-input-wrapper .clear-link').attr('aria-label','Clear search items');
    $('#search-input-wrapper #search-close').attr('role','button');
    $('#search-input-wrapper #search-close').attr('aria-label','Close search');
    // for_tabs_start
    $('.tabbed-collection-links .collection-link-outer button').on('click', function() {
        $('.collection-link-outer button').removeClass('active-collection').attr('aria-selected', 'false');
  
        $(this).addClass('active-collection').attr('aria-selected', 'true');
        });

const elements = document.querySelectorAll('.swatch input');

function updateAriaChecked() {
  elements.forEach(element => {
    if (element.classList.contains('active')) {
      element.setAttribute('aria-checked', 'true');
    } else {
      element.setAttribute('aria-checked', 'false');
    }
  });
}

updateAriaChecked();

const observer = new MutationObserver(updateAriaChecked);
elements.forEach(element => observer.observe(element, { attributes: true, attributeFilter: ['class'] }));
$('.header-wrapper .toggle-filters').click(function (e) {
  e.preventDefault();
  $(this).attr('aria-expanded', function (i, attr) {
    return attr == 'false' ? 'true' : 'false'
  });
});

$(".h7.show-klarna-afterpay-modal").on("click", function () {
  setTimeout(function () {
    $("#klarna-afterpay-popup__close").attr("tabindex", 0).focus();
  }, 1000);
});

$("#klarna-afterpay-popup__close").on("click", function () {
  setTimeout(function () {
    $(".h7.show-klarna-afterpay-modal").attr("tabindex", 0).focus();
  }, 1000);
});

});

  

$(document).ready(function () {
    setTimeout(function () {
        $(".product-modify").each(function() {
            var ariaTitle = $(this).find(".required input").attr('label');
            $(this).find(".required input").attr("aria-label", ariaTitle);
        });
        $(".products > .order-note").each(function() {
            var ariaText = $(this).find("textarea[name='order-note']").attr('placeholder');
            $(this).find("textarea[name='order-note']").attr("aria-label", ariaText);
        });

    }, 3000);
}, 3000);


$(document).ready(function () {
  var existCondition = setInterval(function () {
      if ($('.upsell-text select').length) {
          clearInterval(existCondition);
          runMyFunctionrmvtb();
      }
  }, 200);

  function runMyFunctionrmvtb() {
    $('.upsell-text select').attr('aria-label','Select Color');
  }
});


jQuery(function($) {
  function rearrangeElements() {
      if ($(window).width() > 767) {
          $('.row-reverse .column-12-tablet-vert-6.block-description-wrapper')
              .insertBefore('.row-reverse .column-12-tablet-vert-6:first');
              $('.row-reverse').addClass('ada-seq').removeClass('row-reverse');
      }
  }

  // Run on page load
  rearrangeElements();

  // Run on window resize
  $(window).on('resize', function() {
      rearrangeElements();
  });
});


$(document).ready(function() {
  $('a[role="button"]').on('click', function() {
    var $parentLi = $(this).closest('li');
    
    // Close all other submenus before opening the clicked one
    $('li.open').not($parentLi).removeClass('open').find('a[role="button"]').attr('aria-expanded', 'false');
    
    // Toggle the clicked submenu
    $parentLi.toggleClass('open');
    
    // Update aria-expanded
    var isExpanded = $parentLi.hasClass('open');
    $(this).attr('aria-expanded', isExpanded ? 'true' : 'false');
  });

  // Disable hover behavior
  $('li').hover(
    function() {},
    function() {}
  );
});




// $(document).ready(function() {
//   // Ensure Font Awesome is loaded
//   if (!$('link[href*="font-awesome"]').length) {
//     $('head').append('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">');
//   }

//   // Select all video containers with the class inline-video
//   $('.image-wrap.inline-video').each(function() {
//     // Find the video element within the container
//     var video = $(this).find('video')[0];

//     // Ensure the video is paused by default
//     video.pause(); // This will pause the video initially, overriding autoplay

//     // Prevent lightbox popup behavior when clicking the video container
//     $(this).on('click', function(e) {
//       e.stopPropagation(); // Prevent the click from propagating to the lightbox handler
//     });

//     // Create a play/pause button with Font Awesome icons
//     var playPauseBtn = $('<button class="playPauseBtn"><i class="fas fa-play aria-label="Play Video"></i></button>').css({
//       position: 'absolute',
//       top: '10px', // Position from the bottom
//       right: '10px',   // Position from the left
//       padding: '10px 15px',
//       backgroundColor: 'transparent', // Semi-transparent background
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: '24px',
//       color: 'white',
//       borderRadius: '50%', // Round button shape
//       zIndex: 2, // Ensure the button stays on top
//     });

//     // Append the button to the video container
//     $(this).append(playPauseBtn);

//     // Play/pause functionality
//     playPauseBtn.on('click', function() {
//       if (video.paused) {
//         video.play();
//         $(this).html('<i class="fas fa-pause" aria-label="Pause Video"></i>'); // Change icon to pause with label
//       } else {
//         video.pause();
//         $(this).html('<i class="fas fa-play" aria-label="Play Video"></i>'); // Change icon to play with label
//       }
//     });
//   });
// });

$(document).ready(function() {
  // Ensure Font Awesome is loaded
  if (!$('link[href*="font-awesome"]').length) {
    $('head').append('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">');
  }

  // Select all video containers with the class inline-video
  $('.image-wrap.inline-video').each(function() {
    // Find the video element within the container
    var video = $(this).find('video')[0];

    // Ensure the video is paused by default
    video.pause(); 

    // Prevent lightbox popup behavior when clicking the video container
    $(this).on('click', function(e) {
      e.stopPropagation();
    });

    // Create a play/pause button (ARIA label on button, not icon)
    var playPauseBtn = $('<button class="playPauseBtn" aria-label="Play Video"><i class="fas fa-play"></i></button>').css({
      position: 'absolute',
      top: '10px',
      right: '10px',
      padding: '10px 15px',
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer',
      fontSize: '24px',
      color: 'white',
      borderRadius: '50%',
      zIndex: 2
    });

    // Append the button to the video container
    $(this).append(playPauseBtn);

    // Play/pause functionality
    playPauseBtn.on('click', function() {
      if (video.paused) {
        video.play();
        $(this)
          .html('<i class="fas fa-pause"></i>')
          .attr('aria-label', 'Pause Video'); 
      } else {
        video.pause();
        $(this)
          .html('<i class="fas fa-play"></i>')
          .attr('aria-label', 'Play Video');
      }
    });
  });
});


$(document).ready(function() {
  // Hide the div#product-lightbox when the playPauseBtn is clicked
  $('.playPauseBtn').click(function() {
    $('#product-lightbox').css('display', 'none');
  });

  // Hide the div#product-lightbox when the video element is clicked
  $('video').click(function() {
    $('#product-lightbox').css('display', 'none');
  });
});

$(document).ready(function () {
  const $swatches = $(".swatches[role='radiogroup'] li[role='radio']");

  // Initialize ARIA attributes
  $swatches.each(function () {
    const isActive = $(this).hasClass("active");
    const isDisabled = $(this).hasClass("oos");

    $(this)
      .attr("aria-checked", isActive ? "true" : "false")
      .attr("aria-disabled", isDisabled ? "true" : "false")
      .attr("tabindex", isActive ? "0" : "-1"); // ensure keyboard focus
  });

  // Handle clicks and update ARIA states dynamically
  $swatches.on("click", function () {
    const isDisabled = $(this).attr("aria-disabled") === "true";
    if (isDisabled) return; // prevent selecting disabled swatches

    // Reset all swatches
    $swatches
      .attr("aria-checked", "false")
      .attr("tabindex", "-1")
      .removeClass("active");

    // Set active swatch
    $(this)
      .attr("aria-checked", "true")
      .attr("tabindex", "0")
      .addClass("active")
      .focus();
  });
});
